export const RESET = 'BRAND_UPDATE_RESET'
export const SET_ERROR = 'BRAND_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'BRAND_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'BRAND_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'BRAND_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'BRAND_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'BRAND_UPDATE_UPDATE_RETRIEVED'
